module.exports = __webpack_public_path__ + "static/media/page_loading.5e0ac9be.gif";